const FaqView = () => import('@/views/faq/FaqView')

const prefix = '/f'

export default Object.freeze({
  BOARD: {
    name: 'faqView',
    path: `${prefix}/questions`,
    title: 'duvidas',
    component: FaqView
  }
})
